import React, { Component } from "react";
import { MdSearch } from "react-icons/md";
import io from "socket.io-client";
const url = "https://transacoes-api.all.com.br:3080";

//let value = "";

class SearchOldItems extends Component {
  state = {
    placeholder: "Pesquisar por item..."
  };

  socket = io(url);

  async componentDidMount() {
    this.eventListenerSocket();
    //value = "";
  }

  eventListenerSocket = () => {
    this.socket.on("data", () => {
      //value = "";
      if (this.refs.search) this.refs.search.value = "";
    });
  };

  setValue = value => {
    //value = e;
    this.props.handleSearchOldItems(value);
  };

  render() {
    return (
      <React.Fragment>
        <div
          className="container"
          style={{
            position: "relative"
          }}
        >
          <div
            className="row justify-content-center"
            style={{ paddingTop: "25px" }}
          >
            <div className="col-12">
              <form
                className="box-search"
                style={{
                  backgroundColor: "none",
                  boxShadow:
                    "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)"
                }}
              >
                <div
                  className=" row align-items-center"
                  style={{
                    marginLeft: "0",
                    marginRight: "0"
                  }}
                >
                  <div className="col s12">
                    <input
                      ref="search"
                      style={{ marginTop: "10px" }}
                      type="text"
                      required
                      onChange={e => this.setValue(e.target.value)}
                      placeholder="Pesquisar por item..."
                      title="Buscar item por: Remetente, Destinatário, Tipo, Descrição, Patrimônio, Observação."
                    />
                  </div>

                  <div className="col-auto" style={{ fontSize: "1.5rem" }}>
                    <MdSearch style={{ marginTop: "20px" }} />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SearchOldItems;
